<template>
  <td v-html="value" />
</template>

<script>
import Locale from '../../../../services/locale'
import Common from '../../../../services/common'

export default {
  name: 'ValueCell',
  props: {
    lead: Object,
    fieldId: Number,
    localeService: Locale,
    dateFormat: Object,
    renderParams: Object,
  },
  computed: {
    option() {
      const options = this.renderParams.optionsNames
      const option = options?.find((o) => Number(o.id) === Number(this.fieldId))
      return option
    },
    value() {
      let candidateField = this.lead.custom_fields_values?.find(
        (cf) => cf.field_id === this.fieldId && cf.values,
      )
      if (!candidateField) {
        if (this.option?.type === 'checkbox') {
          candidateField = Common.getDefaultField(this.option)
        } else if (this.fieldId === 1) {
          candidateField = {
            field_type: 'numeric',
            field_name: 'Комиссия',
            field_id: 1,
            values: [
              {
                value: this.lead.price,
              },
            ],
          }
        }
      }
      const formattedCf = Common.getFormattedField({
        field: candidateField,
        dateFormat: this.dateFormat,
        fieldsConfig: this.renderParams.hidingFieldsConfig,
        currencyDict: this.renderParams.currencyDict,
        priceFrom: this.renderParams.config.priceFrom,
        priceFieldId: this.renderParams.config.price,
        currencySymbol: this.renderParams.currency.symbol_native,
        localeService: this.localeService,
      })
      return formattedCf?.valueHtml || '-'
    },
  },
}
</script>
